/**
 * Copyright 2017 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import messages from './messages/PaidFeatures_messages';

import Button from '../../components/Button';

const propTypes = {
  isSuperUser: PropTypes.bool,
  onDisablePortfolio: PropTypes.func.isRequired,
};

const PortfolioEnabled = ({ isSuperUser, onDisablePortfolio }) => (
  <React.Fragment>
    {isSuperUser && (
      <Button
        className="toggle-portfolio-button"
        color="red"
        onClick={onDisablePortfolio}
      >
        <FormattedHTMLMessage
          {...messages.disablePortfolio}
          info="Button text"
        />
      </Button>
    )}
  </React.Fragment>
);

PortfolioEnabled.propTypes = propTypes;

export default PortfolioEnabled;
